<template>
    <form-wrapper class="intake-health-q" @submit="handleFormSubmission(data)">
        <intake-form-section v-for="section in sections" :key="section.key" :title="section.title">
            <form-row v-for="item in section.items" :key="item.path">
                <form-cell>
                    <tabs-field
                        :label="item.label"
                        :options="statusOptions"
                        :formData="data"
                        :valuePath="item.path"
                        size="small"
                        @change="change($event)"
                    ></tabs-field>
                </form-cell>
            </form-row>
        </intake-form-section>

        <template #footer>
            <common-buttons>
                <common-button
                    :label="$t('common.microcopy.back')"
                    type="secondary"
                    size="large"
                    :isSubmittable="false"
                    @click="goBack"
                ></common-button>
                <common-button
                    :label="$t('common.microcopy.next')"
                    type="primary"
                    size="large"
                    :isProcessing="isSending"
                ></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import IntakeFormSection from 'components/forms/intake/IntakeFormSection'

    const HEALTH_SECTIONS = [
        {
            key: 'constitutional',
            items: ['fever', 'chills', 'unexplained_weight_loss', 'fatigue'],
        },
        {
            key: 'eyes',
            items: ['vision_change', 'double_vision'],
        },
        {
            key: 'cardiovascular',
            items: ['chest_pain', 'palpitations'],
        },
        {
            key: 'respiratory',
            items: ['shortness_of_breath', 'cough'],
        },
        {
            key: 'gastrointestinal',
            items: ['abdominal_pain', 'nausea_vomiting', 'bowel_control_changes'],
        },
        {
            key: 'genitourinary',
            items: ['urinary_difficulty', 'bladder_control_changes'],
        },
        {
            key: 'musculoskeletal',
            items: [
                'neck_pain',
                'back_pain',
                'shoulder_pain',
                'arm_pain',
                'hip_pain',
                'knee_pain',
                'joint_pain',
                'stiffness',
                'muscle_spasm',
                'difficulty_walking',
            ],
        },
        {
            key: 'neurologic',
            items: [
                'headache',
                'dizziness',
                'weakness',
                'numbness',
                'tingling',
                'balance_difficulty',
                'fainting',
                'memory_difficulty',
            ],
        },
        {
            key: 'psychiatric',
            items: ['anxiety', 'depression', 'sleep_disturbance'],
        },
    ]

    const STATUS_OPTIONS = ['present', 'absent', 'unknown']

    const ALL_ITEM_PATHS = HEALTH_SECTIONS.reduce((paths, section) => {
        return paths.concat(section.items)
    }, [])

    export default {
        mixins: [FormMixin],

        components: {
            IntakeFormSection,
        },

        props: {
            initialData: { type: Object, default: undefined },
        },

        data() {
            const defaults = ALL_ITEM_PATHS.reduce((acc, path) => {
                acc[path] = undefined
                return acc
            }, {})

            return {
                data: {
                    ...defaults,
                    ...(this.initialData || {}),
                },
            }
        },

        computed: {
            sections() {
                return HEALTH_SECTIONS.map((section) => ({
                    key: section.key,
                    title: this.$t(`forms.intake.health_questions.sections.${section.key}`),
                    items: section.items.map((path) => ({
                        path,
                        label: this.$t(`forms.intake.health_questions.fields.${path}`),
                    })),
                }))
            },

            statusOptions() {
                return STATUS_OPTIONS.map((value) => ({
                    label: this.$t(`forms.intake.health_questions.status.options.${value}`),
                    value,
                }))
            },
        },

        methods: {
            goBack() {
                this.emitEvent({ name: 'back', payload: this.data })
            },

            handleFormSubmission(data) {
                this.isSending = true
                this.emitSent(data)
                this.isSending = false
            },
        },
    }
</script>
